// extracted by mini-css-extract-plugin
export var messageSideLeft = "_n3-1";
export var messageSideRight = "_n3-2";
export var orderLookupBubbleContainer = "_n3-0";
export var submitButton = "_n3-3";